/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';

export interface MarketMakingPlatform {
  id?: number;
  name?: string;
  displayName?: string;
  apiPath?: string;
  hedgeAccountId?: number;
  hedgeAccount?: Account;
  hidden?: boolean;
}
